module.exports = __webpack_public_path__ + "static/media/icon-petitcoin.952f97ec.svg";